export function currency(value: number | null | undefined): string {
  const n = typeof value === 'number' ? value : 0
  return n.toLocaleString('en-US', { style: 'currency', currency: 'USD' })
}

export function number(value: number | null | undefined, digits = 0): string {
  const n = typeof value === 'number' ? value : 0
  return n.toLocaleString('en-US', { minimumFractionDigits: digits, maximumFractionDigits: digits })
}

export function date(value: string | null | undefined): string {
  if (!value) return '—'
  const d = new Date(value)
  if (isNaN(d.getTime())) return '—'
  return d.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })
}

export function dateTime(value: string | null | undefined): string {
  if (!value) return '—'
  const d = new Date(value)
  if (isNaN(d.getTime())) return '—'
  return d.toLocaleString('en-US', { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })
}

// Display code for a product: barcode/sku first, else the legacy Inventory_Code.
export function productCode(p: {
  sku?: string | null; scan_number?: string | null
  legacy_pos_inventory_code?: number | null; legacy_ims_inventory_code?: number | null
} | null | undefined): string {
  if (!p) return '—'
  return (p.sku || p.scan_number || p.legacy_pos_inventory_code || p.legacy_ims_inventory_code || '—').toString()
}

export function customerLabel(c: { name?: string | null; company_name?: string | null; first_name?: string | null; last_name?: string | null } | null | undefined): string {
  if (!c) return 'Unknown'
  if (c.name) return c.name
  if (c.company_name) return c.company_name
  const full = [c.first_name, c.last_name].filter(Boolean).join(' ')
  return full || 'Unnamed Customer'
}
